import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button, Divider, Form, Label, Message } from "semantic-ui-react";
import { camelCase, deburr, endsWith, replace } from "lodash";
import moment from "moment";
import {
  FIELD_LABEL,
  FIELD_NAME,
  FIELD_TYPE,
  FIELD_WIDTH,
  FIELD_CONFIG
} from "./constants";

const INITIAL_STATE = {
  loading: false,
  record: null,
  fields: {},
  error: null
};

function isFieldRequired(label) {
  return label[0] === "!";
}

function escapeLabel(label) {
  return replace(label, new RegExp("!|>"), "");
}

function datetimeToDate(datetime) {
  return moment(datetime.substring(0, 10)).format("YYYY-MM-DD");
}

function createFormGroups(fields) {
  let groups = [];
  let groupAux = [];
  let groupWidth = 0;
  let skipNext = false;

  fields.forEach(field => {
    if (!skipNext && groupWidth + field[FIELD_WIDTH] <= 16) {
      groupAux.push(field);
      groupWidth += field[FIELD_WIDTH];
    } else {
      groups.push(groupAux);
      groupAux = [field];
      groupWidth = field[FIELD_WIDTH];
    }

    skipNext =
      endsWith(field[FIELD_LABEL], ">") ||
      field[FIELD_TYPE] === "radio" ||
      field[FIELD_TYPE] === "checkbox"; // TODO create better solution
  });

  if (groupAux.length !== 0) {
    groups.push(groupAux);
  }

  return groups;
}

class AForm extends Component {
  constructor(props) {
    super(props);

    this.state = INITIAL_STATE;
  }

  componentWillMount() {
    let { record } = this.props;
    let fields = {};

    this.props.fields.forEach(field => {
      if (field[FIELD_TYPE] === "checkbox") {
        field[FIELD_CONFIG].options.forEach(f => {
          fields[f[1]] = {
            type: field[FIELD_TYPE],
            loading: false,
            options: [],
            value: record && record.id ? !!record[f[1]] : false,
            errors: []
          };
        });
      } else if (field[FIELD_TYPE] === "radio") {
        fields[field[FIELD_NAME]] = {
          type: field[FIELD_TYPE],
          loading: false,
          options: [],
          value:
            record && record.id
              ? record[field[FIELD_NAME]]
              : field[FIELD_CONFIG].defaultValue,
          errors: []
        };
      } else {
        fields[field[FIELD_NAME]] = {
          type: field[FIELD_TYPE],
          loading: false,
          options: [],
          value: record && record.id ? record[field[FIELD_NAME]] : "",
          errors: []
        };
      }
    });

    this.setState({
      fields: fields,
      record: this.props.record
    });
  }

  componentDidMount() {
    this.props.fields.forEach(field => {
      if (field[FIELD_TYPE] === "asyncselect" && field[FIELD_CONFIG]) {
        this.setState({
          fields: {
            ...this.state.fields,
            [field[FIELD_NAME]]: {
              ...this.state.fields[field[FIELD_NAME]],
              loading: true
            }
          }
        });
        // console.log("FIELD PARAMS", field);
        field[FIELD_CONFIG].service
          .find(field[FIELD_CONFIG].params || {})
          .then(response => {
            this.setState({
              fields: {
                ...this.state.fields,
                [field[FIELD_NAME]]: {
                  ...this.state.fields[field[FIELD_NAME]],
                  loading: false,
                  options: response.records.map(field[FIELD_CONFIG].mapFunction)
                }
              }
            });
          })
          .catch(error => {
            this.setState({
              fields: {
                ...this.state.fields,
                [field[FIELD_NAME]]: {
                  ...this.state.fields[field[FIELD_NAME]],
                  loading: false,
                  errors: [error]
                }
              }
            });
          });
      }
    });
  }

  createInputHandler(name, type = "input") {
    return (e, input) => {
      let valueSelector = {
        input: () => {
          return e.target.value;
        },
        number: () => {
          return e.target.value;
        },
        radio: () => {
          return input.value;
        },
        checkbox: () => {
          return !this.state.fields[name].value;
        },
        select: () => {
          return input.value;
        },
        asyncselect: () => {
          return input.value;
        },
        date: () => {
          return e.target.value;
        },
        datetime: () => {
          return e.target.value;
        },
        textarea: () => {
          return e.target.value;
        }
      };

      this.setState({
        fields: {
          ...this.state.fields,
          [name]: {
            ...this.state.fields[name],
            value: valueSelector[type]()
          }
        }
      });
    };
  }

  createInput(field, index) {
    let stateField = this.state.fields[field[FIELD_NAME]];
    let inputSelector = {
      input: () => {
        return (
          <Form.Input
            key={index}
            label={escapeLabel(field[FIELD_LABEL])}
            width={field[FIELD_WIDTH]}
            required={isFieldRequired(field[FIELD_LABEL])}
            value={stateField.value}
            onChange={this.createInputHandler(
              field[FIELD_NAME],
              field[FIELD_TYPE]
            )}
          />
        );
      },
      number: () => {
        return (
          <Form.Input
            key={index}
            label={escapeLabel(field[FIELD_LABEL])}
            type="number"
            width={field[FIELD_WIDTH]}
            required={isFieldRequired(field[FIELD_LABEL])}
            value={stateField.value}
            onChange={this.createInputHandler(
              field[FIELD_NAME],
              field[FIELD_TYPE]
            )}
          />
        );
      },
      label: () => {},
      radio: () => {
        return [
          <label>{field[FIELD_LABEL]}</label>,
          ...field[FIELD_CONFIG].options.map((option, index) => (
            <Form.Radio
              key={index}
              label={option[0]}
              value={option[1]}
              checked={this.state.fields[field[FIELD_NAME]].value === option[1]}
              onChange={this.createInputHandler(
                field[FIELD_NAME],
                field[FIELD_TYPE]
              )}
            />
          ))
        ];
      },
      checkbox: () => {
        return [
          <label>{field[FIELD_LABEL]}</label>,
          ...field[FIELD_CONFIG].options.map((option, index) => (
            <Form.Checkbox
              key={index}
              label={option[0]}
              checked={this.state.fields[option[1]].value}
              onChange={this.createInputHandler(option[1], field[FIELD_TYPE])}
            />
          ))
        ];
      },
      select: () => {
        return (
          <Form.Select
            key={index}
            label={escapeLabel(field[FIELD_LABEL])}
            width={field[FIELD_WIDTH]}
            required={isFieldRequired(field[FIELD_LABEL])}
            options={field[FIELD_CONFIG].options}
            value={this.state.fields[field[FIELD_NAME]].value}
            onChange={this.createInputHandler(
              field[FIELD_NAME],
              field[FIELD_TYPE]
            )}
          />
        );
      },
      asyncselect: () => {
        return (
          <Form.Select
            key={index}
            label={escapeLabel(field[FIELD_LABEL])}
            search
            width={field[FIELD_WIDTH]}
            required={isFieldRequired(field[FIELD_LABEL])}
            options={stateField.options}
            loading={stateField.loading}
            value={this.state.fields[field[FIELD_NAME]].value}
            onChange={this.createInputHandler(
              field[FIELD_NAME],
              field[FIELD_TYPE]
            )}
          />
        );
      },
      date: () => {
        return (
          <Form.Field
            key={index}
            label={escapeLabel(field[FIELD_LABEL])}
            control={"input"}
            type="date"
            width={field[FIELD_WIDTH]}
            required={isFieldRequired(field[FIELD_LABEL])}
            value={datetimeToDate(this.state.fields[field[FIELD_NAME]].value)}
            onChange={this.createInputHandler(
              field[FIELD_NAME],
              field[FIELD_TYPE]
            )}
          />
        );
      },
      datetime: () => {
        return (
          <Form.Field
            key={index}
            label={escapeLabel(field[FIELD_LABEL])}
            control={"input"}
            type="date"
            width={field[FIELD_WIDTH]}
            required={isFieldRequired(field[FIELD_LABEL])}
            value={datetimeToDate(this.state.fields[field[FIELD_NAME]].value)}
            onChange={this.createInputHandler(
              field[FIELD_NAME],
              field[FIELD_TYPE]
            )}
          />
        );
      },
      textarea: () => {
        return (
          <Form.Field
            key={index}
            label={escapeLabel(field[FIELD_LABEL])}
            control={"textarea"}
            {...field[FIELD_CONFIG]}
            width={field[FIELD_WIDTH]}
            required={isFieldRequired(field[FIELD_LABEL])}
            value={this.state.fields[field[FIELD_NAME]].value}
            onChange={this.createInputHandler(
              field[FIELD_NAME],
              field[FIELD_TYPE]
            )}
          />
        );
      }
    };

    return inputSelector[field[FIELD_TYPE]]();
  }

  submitForm(e) {
    e.preventDefault();

    this.setState({
      loading: true
    });

    let { record, fields } = this.state;
    let {
      options: { serviceParams }
    } = this.props;
    let values = {};

    Object.keys(this.state.fields).forEach(field => {
      values[field] = fields[field].value;
    });

    if (serviceParams) {
      values = {
        ...values,
        ...serviceParams
      };
    }

    if (record && record.id) {
      this.props.service
        .patch(record.id, values)
        .then(response => {
          this.setState({
            loading: false
          });

          this.props.doneSubmiting(response);
        })
        .catch(error => {
          this.setState({
            loading: false,
            error: error
          });
        });
    } else {
      this.props.service
        .create(values)
        .then(response => {
          this.setState({
            loading: false
          });

          this.props.doneSubmiting(response);
        })
        .catch(error => {
          this.setState({
            loading: false,
            error: error
          });
        });
    }
  }

  render() {
    let { loading, fields, error } = this.state;
    let fieldGroups = createFormGroups(this.props.fields);

    return (
      <Form onSubmit={this.submitForm.bind(this)} loading={loading}>
        {fieldGroups.map((
          group,
          i // TODO create better solution
        ) => (
          <Form.Group
            key={i}
            inline={group.some(field => field[FIELD_TYPE] === "radio")}
            grouped={group.some(field => field[FIELD_TYPE] === "checkbox")}
            children={group.map((field, index) =>
              this.createInput(field, index)
            )}
          />
        ))}
        {error && (
          <Message negative>
            <Message.Header>Error! {error.message}</Message.Header>
            <pre>{error.name}</pre>
          </Message>
        )}
        <Divider />
        <Button
          type="button"
          basic
          negative
          content="Cancelar"
          onClick={this.props.dismiss}
        />
        <Button
          type="submit"
          positive
          floated="right"
          content="Aceptar"
          onClick={this.submitForm.bind(this)}
        />
      </Form>
    );
  }
}

AForm.propTypes = {
  fields: PropTypes.arrayOf(PropTypes.array).isRequired,
  service: PropTypes.shape({
    create: PropTypes.func.isRequired,
    update: PropTypes.func.isRequired,
    patch: PropTypes.func.isRequired
  }).isRequired,
  options: PropTypes.shape({
    serviceParams: PropTypes.object
  }),
  dismiss: PropTypes.func.isRequired,
  doneSubmiting: PropTypes.func.isRequired
};

AForm.defaultProps = {
  options: {}
};

export default AForm;



// WEBPACK FOOTER //
// ./client/components/auto/AForm.js